import React from 'react';
import PremiumCard from '../ui/PremiumCard';
import ActivityHistory from '../features/ActivityHistory';

const HistoryTab = ({ userHistory, currentPage, setCurrentPage, itemsPerPage }) => {
  const totalPages = Math.ceil(userHistory.length / itemsPerPage);
  return (
    <div className="space-y-8">
      <PremiumCard>
        <ActivityHistory 
          history={userHistory}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      </PremiumCard>
    </div>
  );
};
export default HistoryTab;